import {
  isMultiValuedListVariantTag,
  MultiValuedListItem,
} from '../../MultiValuedList'
import { UserMultiValue } from '../UserMultiValue'

import {
  USER_MULTI_VALUE_LIST_ITEM_AVATAR_SIZE,
  USER_MULTI_VALUE_LIST_ITEM_TAG_AVATAR_SIZE,
} from './UserMultiValuedListItem.constants'

function UserMultiValuedListItem({
  Content,
  Icon,
  done,
  unread,
  user,
  variant,
  ...itemProps
}) {
  return (
    <MultiValuedListItem {...itemProps} variant={variant}>
      <UserMultiValue
        Content={Content}
        Icon={Icon}
        avatarSize={
          isMultiValuedListVariantTag(variant)
            ? USER_MULTI_VALUE_LIST_ITEM_TAG_AVATAR_SIZE
            : USER_MULTI_VALUE_LIST_ITEM_AVATAR_SIZE
        }
        done={done}
        unread={unread}
        user={user}
      />
    </MultiValuedListItem>
  )
}

export default UserMultiValuedListItem
